/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { BillingPricing } from './BillingPricing';
// @ts-ignore
import {
// @ts-ignore
    BillingPricingFromJSON,
// @ts-ignore
    BillingPricingFromJSONTyped,
// @ts-ignore
    BillingPricingToJSON,
} from './BillingPricing';

/**
 * 
 * @export
 * @interface BillingPricingListResponse
 */
export interface BillingPricingListResponse {
    /**
     * 
     * @type {Array<BillingPricing>}
     * @memberof BillingPricingListResponse
     */
    items: Array<BillingPricing>;
}

/**
 * Check if a given object implements the BillingPricingListResponse interface.
 */
// @ts-ignore
export function instanceOfBillingPricingListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function BillingPricingListResponseFromJSON(json: any): BillingPricingListResponse {
    return BillingPricingListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingPricingListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingPricingListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(BillingPricingFromJSON)),
    };
}

// @ts-ignore
export function BillingPricingListResponseToJSON(value?: BillingPricingListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(BillingPricingToJSON)),
    };
}

